import { useTranslation } from 'react-i18next'
import { Box, Typography, Stack, Divider, Switch, Tooltip } from '@mui/material'
import CircleIcon from '@mui/icons-material/Circle'
import { Controller, useForm } from 'react-hook-form'
import { LegendPopper } from './LegendsStyles'
import {
  availableToColor,
  availableToTranslationKey,
} from 'pages/Supervision/helpers'

const BuildingLegend = ({
  onStateFiltersChange = () => {},
  ...props
}) => {
  const { t } = useTranslation()
  const { control} =
    useForm({
      defaultValues: {
        hibernation: true,
        works: true,
        planned: true
      }
    })

  const EquipmentMapping = {
    wifi_hotspot: <i className="fa-light fa-signal-stream" />,
    switch: <i className="fa-light fa-ethernet" />,
    esl: <i className="fa-light fa-rectangle-barcode" />,
    chromecast: <i className="fa-light fa-screencast" />,
    tv: <i className="fa-light fa-tv" />,
  }

  return (
    <LegendPopper {...props}>
      <Box sx={{ minWidth: '200px' }}>
        <Divider
          sx={{
            width: '100%',
            fontSize: '10px',
            whiteSpace: 'nowrap',
            textTransform: 'uppercase',
            color: 'content.tertiary',
            pb: 2,
          }}
        >
          {t('cartography.maps.legend.supervised_equipments')}
        </Divider>
        <Stack gap={1}>
          {['up', 'down'].map((state) => (
            <Stack key={state} direction="row" justifyContent="space-between">
              <Typography
                sx={{
                  fontSize: '12px',
                  lineHeight: '16px',
                  fontWeight: '400',
                  color: 'content.primary',
                  textTransform: 'capitalize',
                }}
              >
                {t(availableToTranslationKey(state))}
              </Typography>
              <CircleIcon
                sx={{ fontSize: '18px', color: availableToColor(state) }}
              />
            </Stack>
          ))}
        </Stack>
        <Divider
          sx={{
            width: '100%',
            fontSize: '10px',
            whiteSpace: 'nowrap',
            textTransform: 'uppercase',
            color: 'content.tertiary',
            py: 2,
          }}
        >
          {t('cartography.maps.legend.no_supervised_equipments')}
        </Divider>
        <Stack gap={1}>
          {['hibernation', 'works', 'planned'].map((state) => (
            <Stack
              key={state}
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              gap={1}
            >
              <Tooltip title={t(availableToTranslationKey(state))}>
                <Typography
                  sx={{
                    fontSize: '12px',
                    lineHeight: '16px',
                    fontWeight: '400',
                    color: 'content.primary',
                    textTransform: 'lowercase',
                    whiteSpace: 'nowrap',
                    "&::first-letter": {
                      textTransform: 'uppercase'
                    }
                  }}
                >
                  {t(availableToTranslationKey(state, '_short'))}
                </Typography>
              </Tooltip>
              <Controller
                control={control}
                name={state}
                defaultValue={true}
                render={({ field: { onChange, value } }) => {
                  return (
                    <Switch
                      size="small"
                      defaultChecked
                      value={value}
                      onChange={(event) => {
                        onStateFiltersChange(state, event.target.checked)
                        onChange(event)
                      }}
                      sx={{
                        '& .MuiSwitch-switchBase.Mui-checked': {
                          color: availableToColor(state),
                        },
                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track':
                          {
                            backgroundColor: availableToColor(state),
                            opacity: 0.4,
                          },
                      }}
                    />
                  )
                }}
              />
            </Stack>
          ))}
        </Stack>
        <Divider
          sx={{
            width: '100%',
            fontSize: '10px',
            whiteSpace: 'nowrap',
            textTransform: 'uppercase',
            color: 'content.tertiary',
            p: 2,
          }}
        >
          {t('cartography.maps.legend.legend')}
        </Divider>
        <Stack>
          {Object.keys(EquipmentMapping).map((key) => (
            <Stack
              key={key}
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography
                sx={{
                  fontSize: '12px',
                  lineHeight: '16px',
                  fontWeight: '400',
                  color: 'content.primary',
                  textTransform: 'capitalize',
                  whiteSpace: 'nowrap',
                }}
              >
                {t(`cartography.maps.legend.${key}`)}
              </Typography>
              <Box sx={{ width: '20px', color: 'content.secondary' }}>
                {EquipmentMapping[key]}
              </Box>
            </Stack>
          ))}
        </Stack>
      </Box>
    </LegendPopper>
  )
}

export default BuildingLegend
